import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@zawarski/eti-ui/styles.css';
import 'theme/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
